<template>
    <div class="SensitiveWords spackage padding-20 bgc box-shadow">
        <!-- start 顶部菜单栏 -->
        <section class="startMgt-header">
            <el-button type="primary" align="left" @click="addNewWords()">新建关键词</el-button>
            <el-button @click="importEvent">批量导入</el-button>
        </section>
        <!-- end 顶部菜单栏 -->
        <section>
            <el-table :data="wordsData" @selection-change="selsChange">
                <el-table-column type="selection" width="55"></el-table-column>
                <el-table-column type="index" width="50" label="序号" align="center"></el-table-column>
                <el-table-column prop="keyword" label="关键词" align="center"></el-table-column>
                <el-table-column prop="replaceword" label="替换词" align="center"></el-table-column>
                <el-table-column prop="datetime" label="入库时间" align="center"></el-table-column>
                <el-table-column label="操作" align="right">
                    <template slot-scope="scope">
                        <div class="table-position">
                            <span @click="editClick(scope.row.innerid, scope.row.keyword, scope.row.replaceword)">编辑</span>
                            <span>｜</span>
                            <span @click="delClick(scope.row.innerid)">删除</span>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <el-button class="allDel_btn" @click="handleDelete(sels)">批量删除</el-button>
            <page :total="total" ref="page" @getList="searchClick"></page>
        </section>
        <!-- start 弹窗 -->
        <el-dialog title="新增关键词" :visible.sync="dialogFormVisible">
            <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
                <el-form-item label="关键词" prop="words">
                    <el-input v-model="ruleForm.words" maxlength="10" show-word-limit placeholder="请输入关键词"></el-input>
                </el-form-item>
                <el-form-item label="替换词">
                    <el-input v-model="ruleForm.replaceWords" maxlength="10" show-word-limit
                              placeholder="请输入替换词"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisible = false">取 消</el-button>
                <el-button type="primary" @click="sureAdd()">确 定</el-button>
            </div>
        </el-dialog>
        <!-- end 弹窗 -->

        <!-- start 弹窗 -->
        <el-dialog title="编辑关键词" :visible.sync="dialogEdit">
            <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
                <el-form-item label="关键词" prop="words">
                    <el-input v-model="ruleForm.words" maxlength="10" show-word-limit placeholder="请输入关键词"></el-input>
                </el-form-item>
                <el-form-item label="替换词">
                    <el-input v-model="ruleForm.replaceWords" maxlength="10" show-word-limit
                              placeholder="请输入替换词"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogEdit = false">取 消</el-button>
                <el-button type="primary" @click="sureEdit()">确 定</el-button>
            </div>
        </el-dialog>
        <!-- end 弹窗 -->

        <!-- start 弹窗 -->
        <el-dialog title="批量导入" :visible.sync="dialogImport">
            <div class="import_box">
                <label>使用模板</label>
                <div>
                    <span class="downLoad" @click="downLoadEvent">模板下载</span>
                    <p>使用模版可以快速编辑</p>
                </div>
            </div>
            <div class="import_box">
                <label>导入文件</label>
                <div>
                    <el-upload class="upload-pdf" ref="myUpload" action="" accept="xls" :auto-upload="false" :on-change="handleImport" :on-exceed="handleExceed" :before-remove="beforeRemove">
                        <el-button size="small" type="primary">点击上传</el-button>
                    </el-upload>
                </div>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogImport = false">取 消</el-button>
                <el-button type="primary" @click="sureImport()">确 定</el-button>
            </div>
        </el-dialog>
        <!-- end 弹窗 -->
    </div>
</template>

<script>
    import {getWordsList, saveWords, delWords,downloadWords,importWords} from '@/api/starMgtApi'
    import Loading from 'base/loading/loading' // 引入 loading 组件
    import {mapGetters, mapActions} from 'vuex'
    import Page from 'base/page/page'
    import {dateFormat,computeFileSize} from 'common/js/tools'
    import UploadFile from 'base/upload/uploadFile'
    export default {
        name: 'SensitiveWords',
        data() {
            return {
                fileList:[],
                loading: false, // 加载
                dialogFormVisible: false,
                dialogEdit: false,
                dialogImport: false,
                formLabelWidth: '80px',
                total: 0,   //表格页数
                wordsData: [],   //表格数据
                searchName: '', //搜索话题
                sels: [],//选中显示的值
                ruleForm: {
                    words: '',
                    replaceWords: '',
                },
                rules: {
                    words: [
                        {required: true, message: '请输入关键词', trigger: 'blur'},
                    ],
                },
                form:{
                    logodata: [],
                },
                fileInfo:''
            }
        },
        components: {
            Loading,
            Page,
            UploadFile
        },
        mounted() {
            this.setLoading(true);
            this.apiData = {
                starid: this.$route.query.innerid,
                page: 1,
                pageSize: 10
            };
            this.getWordsList()
        },
        methods: {
            handleExceed(files, fileList) {
                console.log(files);
                console.log(fileList)
                // this.$message.warning(`当前限制选择 3 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
            },
            // 移除
            beforeRemove(file, fileList) {
                return this.$confirm(`确定移除 ${ file.name }？`);
            },
            handleImport(file){
                this.fileInfo = file.raw
            },
            // 批量导入
            importEvent() {
                this.dialogImport = true;
                this.$refs.myUpload.clearFiles();
            },
            // 确定导入敏感词
            sureImport() {
                let formData = new FormData()
                formData.append('hostforbidexcel', this.fileInfo)
                this.setLoading(true)
                importWords({
                    data: formData,
                    success: data => {
                        this.dialogImport = false;
                        this.$message.success(data.data.mesg)
                        this.getWordsList()
                    },
                    error: data => {
                        this.dialogImport = false;
                        this.setLoading(false)
                        this.$message.error(data.data.mesg)
                    }
                })
            },
            handleQuery() {
                this.$refs.page.handleSizeChange(1)
            },
            ...mapActions([
                'setLoading'
            ]),
            // 新建关键词
            addNewWords() {
                this.ruleForm.words = '';
                this.ruleForm.replaceWords = '';
                this.dialogFormVisible = true
            },
            // 确定添加关键词
            sureAdd() {
                this.setLoading(true);
                let params = {
                    keyword: this.ruleForm.words,
                    replaceword: this.ruleForm.replaceWords
                };
                console.log(params);
                saveWords({
                    data: Object.assign({}, params, this.page),
                    success: data => {
                        console.log(data);
                        this.setLoading(false);
                        this.dialogFormVisible = false;
                        this.$message({type: 'success', message: '添加成功！'});
                        this.getWordsList()
                    },
                    error: data => {
                        console.log('error：', data);
                        this.setLoading(false);
                        this.dialogFormVisible = false;
                        this.$message.error(data.msg);
                    }
                })
            },
            // 编辑关键词
            editClick(id,keyword,replaceword) {
                this.innerid=id;
                this.ruleForm.words = keyword;
                this.ruleForm.replaceWords = replaceword;
                this.dialogEdit = true;
            },
            // 确定编辑
            sureEdit() {
                this.setLoading(true);
                let params = {
                    innerid: this.innerid,
                    keyword: this.ruleForm.words,
                    replaceword: this.ruleForm.replaceWords
                };
                console.log(params);
                saveWords({
                    data: Object.assign({}, params, this.page),
                    success: data => {
                        console.log(data);
                        this.setLoading(false);
                        this.dialogEdit = false;
                        this.$message({type: 'success', message: '编辑成功！'});
                        this.getWordsList()
                    },
                    error: data => {
                        console.log('error：', data);
                        this.setLoading(false);
                        this.dialogEdit = false;
                        this.$message.error(data.msg);
                    }
                })
            },
            // 删除公告
            delClick(id) {
                this.$confirm('删除后将不可恢复，确认删除吗？', '删除', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消'
                }).then(() => {
                    let params = {
                        innerid: id,
                    };
                    this.setLoading(true);
                    delWords({
                        data: Object.assign({}, params),
                        success: data => {
                            this.setLoading(false);
                            this.getWordsList();
                            this.$message.success(`删除成功!`)
                        },
                        error: data => {
                            this.setLoading(false);
                            console.log('error：', data);
                            this.$message.error(data.msg);
                        }
                    })
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    })
                })
            },
            //公告列表
            getWordsList() {
                getWordsList({
                    data: this.apiData,
                    success: data => {
                        console.log(data);
                        this.setLoading(false);
                        this.wordsData = data.data.content;
                        this.total = data.data.pageinfo.rowCount
                    },
                    error: data => {
                        this.setLoading(false)
                    }
                })
            },
            // 模板下载
            downLoadEvent(){
                downloadWords({
                    data: Object.assign({}, this.param),
                    success: data => {
                        let blob = new Blob([data], {type: 'application/vnd.ms-excel'});
                        let fileName = '敏感词名单' + dateFormat(new Date()) + '.xls';
                        if (window.navigator.msSaveOrOpenBlob) {
                            navigator.msSaveBlob(blob, fileName)
                        } else {
                            const link = document.createElement('a');
                            link.href = window.URL.createObjectURL(blob);
                            link.download = fileName;
                            link.click(); // 释放内存
                            window.URL.revokeObjectURL(link.href)
                        }
                        this.setLoading(false)
                    },
                    error: data => {
                        this.setLoading(false);
                        this.$message.error(data.msg)
                    }
                })
            },
            // 批量删除
            selsChange(sels) {
                this.sels = sels
            },
            handleDelete(idArray) {
                this.$confirm('删除后将不可恢复，确认删除吗？', '删除', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消'
                }).then(() => {
                    let params = [];
                    this.sels.forEach(item=>{
                        params.push(item.innerid)
                    });
                    console.log(params);
                    this.setLoading(true);
                    delWords({
                        data: {innerid:params.join(',')},
                        success: data => {
                            this.setLoading(false);
                            this.getWordsList();
                            this.$message.success(`删除成功!`)
                        },
                        error: data => {
                            this.setLoading(false);
                            console.log('error：', data);
                            this.$message.error(data.msg);
                        }
                    })
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    })
                })
                // this.all = this.all.filter(i => !idArray.includes(i.id));
            },
            // 分页
            searchClick() {
                this.setLoading(true);
                let params ={
                    starid: this.$route.query.innerid,
                }
                getWordsList({
                    data: Object.assign({}, params, this.page),
                    success: data => {
                        this.setLoading(false);
                        this.wordsData = data.data.content;
                        this.total = data.data.pageinfo.rowCount
                    },
                    error: data => {
                        console.log('error：', data);
                        this.setLoading(false)
                    }
                })
            },
        },
        computed: {
            ...mapGetters([
                'page',
                'user'
            ])
        },
    }
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
    @import "~common/scss/starmgt";

    .SensitiveWords .startMgt-header {
        height: 40px;
        margin-bottom: 40px;
    }
    .delBtn{
        margin-top: 20px;
        margin-left: 0;
    }
    .import_box {
        display: flex;
        align-items: center;
        label {
            width: 100px;
            display: inline-block;
        }
        .downLoad {
            width: 300px;
            height: 36px;
            line-height: 36px;
            text-align: center;
            color: #1989FA;
            background: rgba(230, 241, 252, 1);
            border-radius: 4px;
            border: 1px solid rgba(163, 208, 253, 1);
            display: inline-block;
            margin-bottom: 10px;
            cursor: pointer;
        }
        .excFirst{
            background: #409EFF;
            border-radius: 4px;
            border: 1px solid #409EFF;
            color: #fff;
        }
        .upload-excel .upload-excel-info{
            background: #F5F7FA;
            border: 1px solid #F5F7FA;
            color: #333;
        }
        #uploadBtn{
            width: 300px;
            height: 36px;
            opacity: 0;
            position: absolute;
            left: 0;
        }
    }
    .import_box:last-child{
        margin-top: 30px;
    }
    .allDel_btn{
        margin-top: 20px;
    }
    .table-position span{
        cursor: pointer;
    }
    /*上传xls样式更改*/
    .upload-pdf{
        width: 300px;
        .el-button{
            width: 300px;
            height: 36px;
        }
    }
    .el-upload-list__item:first-child{
        width: 300px;
        height: 36px;
        line-height: 36px;
        background: rgba(245,247,250,1);
        padding: 0 10px;
        display: flex;
        justify-content: space-between;
        margin-top: 0;
    }
    .el-upload-list__item .el-icon-upload-success{
        display: none;
    }
    .el-upload-list__item .el-icon-close{
        top: 12px;
    }
    /*公共样式重写*/
    .SensitiveWords .page{
        margin-top: 0;
    }
    .el-dialog .el-button {
        margin-bottom: 10px!important;
    }
</style>
